export enum CommonItemDisplayType {
  PORTAL_CARDS_GRID = 'PortalCardsGrid',
  PORTAL_FAQ_BLOCK = 'PortalFaqBlock',
  PORTAL_FAQ_LIST = 'PortalFaqList',
  PORTAL_IMAGE_GRID = 'PortalImageGrid',
  PORTAL_METRICS_LIST_ITEMS = 'PortalMetricsListitems',
  PORTAL_NEWSLETTER = 'PortalNewsletter',
  PORTAL_REINSURANCE_LIST_ITEMS = 'PortalReinsuranceListitems',
}
